import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Desembolso } from '../../../models/Desembolso';
import { DesembolsoService } from 'app/services/tesoreria/desembolso/desembolso.service';
import Swal from "sweetalert2";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import {DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
    selector:'app-confirmar-desembolso',
    templateUrl:'./confirmar-desembolso.component.html',
    styleUrls:['./confirmar-desembolso.component.scss'],
    providers:[DatePipe,MessagesTitles,MessagesGeneral,MessagesDates,MessagesSimuladorAgregarDetalle,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
    
export class ConfirmarDesembolsoComponent implements OnInit{

  @Output() cerrarDesembolsoDetalle : EventEmitter<boolean> = new EventEmitter();
  @Input() idDesembolso:number = 0;

  formularioConfirmar : FormGroup;
  user : any;

  minDate = moment().add(-7, 'day');
  maxDate = new Date();

  count: number = 0;    
  Confirmar=true;    
  Desembolso: any = [];
  DesembolsoDetalle : any = [];
  desembolsoGeneral: any = [];
  TipoBanco : number;


  //DesembolsoDetalle : DesembolsoDetalle = new DesembolsoDetalle();
  loading : boolean;
  loading1 : boolean;
  loading2 : boolean;
  displayedColumns: string[] =['checked','idSolicitudDesembolso','Importe','Estado']
  displayedColumnsLiq: string[] =['checked','idResumen_Liquidaciones','ImporteLiq','EstadoLiq']
  dataSource:any;
  dataSourceLiq:any;
  constructor(private DesembolsoService:DesembolsoService,
    private datepipe :DatePipe,){
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
  }

  ngOnInit(){
      this.loading = true;
      this.obtenerDesembolso();
      this.obtenerDesembolsoDet();
  }

  MetCerrarDesembolsoDetalle(){
      this.cerrarDesembolsoDetalle.emit();
  }

  limpiar(){
    this.DesembolsoDetalle.map(object => object.checked = false);
  }

  banco(event){
    this.TipoBanco = event;
  }

  obtenerDesembolso(){
      this.loading1 = true;
      let cont = 0;
      this.DesembolsoService.obtenerDesembolsoCab(this.idDesembolso)
      .subscribe(res=>{
          this.Desembolso = res[cont] as Desembolso;
          this.loading1 = false;
          this.loading = (!this.loading2 ? !this.loading : this.loading);
      });
  }

  obtenerDesembolsoDet(){
      this.loading2 = true;
      this.DesembolsoService.obtenerDesembolsoDet(this.idDesembolso)
      .subscribe(res=>{
          this.DesembolsoDetalle = res;// as DesembolsoDetalle;
          this.DesembolsoDetalle.map(array =>{array.checked = true});
          this.dataSource = new MatTableDataSource(this.DesembolsoDetalle)
          this.dataSourceLiq = new MatTableDataSource(this.DesembolsoDetalle)
          this.loading2 = false;
          this.loading = (!this.loading1 ? !this.loading : this.loading);
      });
  }
    
  confirmarDesembolso(idDesembolso){

    if(!this.TipoBanco){
      Swal.fire({
        type: 'warning',
        title: 'Espera',
        text: 'Seleccione un banco',
        heightAuto: false
      })
      return;
    }

    let arraySolicitudDesembolso : any = [];
    let contador :number = 0;

    this.DesembolsoDetalle.forEach(element => {
      arraySolicitudDesembolso.push({'idSolicitudDesembolso': element.idSolicitudDesembolso,'Status':(element.checked ? 1 : 0 )});
      if(element.checked) contador += 1;
    });

    let $html = 'Has selecionado <b> '+contador+' </b> solicitud(es) de desembolso para confirmar la planilla.';

    if(contador <= 0){
      $html = '<span style ="color: red; text-align:center;">'+$html+'<span>' 
      Swal.fire({
        type: 'warning',
        title: 'Espera',
        text: 'Seleccione al menos una solicitud',
        footer: $html,
        heightAuto: false
      })
      return;
    }
    
    $html = '<span style ="color: #4caf50;text-align:center;">'+$html+'<span>'
    
    Swal.fire({
      title:'',
      text:'¿Estás seguro de confirmar la planilla?',
      type: 'warning',
      footer: $html,
      showCancelButton: true,
      confirmButtonText:'Si, confirmar',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result)=>{
      if(result.value){
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud',
          heightAuto: false
        })
        Swal.showLoading();
 
        this.formularioConfirmar = new FormGroup({
          'idDesembolso' : new FormControl(idDesembolso),
          'Fecha' : new FormControl(this.datepipe.transform(this.maxDate,'yyyy-MM-dd')),
          'Banco' : new FormControl(this.TipoBanco),
          'SolicitudDesembolso' : new FormControl(arraySolicitudDesembolso),
          'Alta_Canal' : new FormControl("W"),
          'Alta_Usuario' : new FormControl(this.user.Usuario),
          
        })
        
        this.DesembolsoService.confirmarEstadoDesembolso(this.formularioConfirmar.getRawValue()).subscribe(
          res =>{ 
            Swal.fire({
              title: '¡Planilla confirmada!',
              text: 'La planilla de desembolso ha sido confirmada.',
              type: 'success'
            }).then(resp =>{
              if(resp.value == true){
                this.MetCerrarDesembolsoDetalle();
              }
            });
          },
          err =>{
            Swal.fire({
              title: "Error",
              text: "No se pudo confirmar la planilla seleccionada.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        )
      }
    })
  }
  confirmarDesembolsoLiq(idDesembolso){

    let arrayLiq : any = [];
    let contador :number = 0;

    this.DesembolsoDetalle.forEach(element => {
      arrayLiq.push({'idResumen_Liquidaciones': element.idResumen_Liquidaciones,'Status':(element.checked ? 1 : 0 )});
      if(element.checked) contador += 1;
    });

    let $html = 'Has selecionado <b> '+contador+' </b>  resumen de liquidación(es) para confirmar la planilla.';
    
    if(contador <= 0){
      $html = '<span style ="color: red; text-align:center;">'+$html+'<span>' 
      Swal.fire({
        type: 'warning',
        title: 'Espera',
        text: 'Seleccione al menos un resumen de liquidacón',
        footer: $html,
        heightAuto: false
      })
      return;
    }

    $html = '<span style ="color: #4caf50;text-align:center;">'+$html+'<span>' 

    Swal.fire({
      title:'',
      text:'¿Estás seguro de confirmar la planilla?',
      type: 'warning',
      footer: $html,
      showCancelButton: true,
      confirmButtonText:'Si, confirmar',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result)=>{
      if(result.value){
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud',
          heightAuto: false
        })
        Swal.showLoading();
 
        this.formularioConfirmar = new FormGroup({
          'idDesembolso' : new FormControl(idDesembolso),
          'Fecha' : new FormControl(this.datepipe.transform(this.maxDate,'yyyy-MM-dd')),
          'Banco' : new FormControl(this.TipoBanco),
          'ResumenLiquidaciones' : new FormControl(arrayLiq)
        })
        this.DesembolsoService.confirmarEstadoDesembolsoRemanente(this.formularioConfirmar.getRawValue()).subscribe(
          res =>{ 
            Swal.fire({
              title: '¡Planilla confirmada!',
              text: 'La planilla de Liquidacion ha sido confirmada.',
              type: 'success',
              heightAuto: false
            }).then(resp =>{
              if(resp.value == true){
                this.MetCerrarDesembolsoDetalle();
              }
            });
          },
          err =>{
            Swal.fire({
              title: "Error",
              text: "No se pudo confirmar la planilla seleccionada.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        )
      }
    })
  }
}